export interface MultiTemplateTransactionalEmailActivityCreateRequestModel {
  name: string;
}
